<template>
    <img :src="src" />
</template>

<script>
export default {
    name: 'LazyLoadedImage',
    props: ['src', 'srcset', 'alt'],
};
</script>

<style scoped></style>
